<template>
  <div>
      <v-container fluid>
          <v-row>
              <v-col md="12" sm="12">
                    <v-card class="mx-auto" outlined>
                        <v-card-title>
                            TRANSFERENCIAS
                            <div class="flex-grow-1"></div>
                            <v-text-field
                                v-model="search"
                                append-icon="fa-search"
                                label="Buscar..."
                                single-line
                                hide-details
                                :disabled="loading"
                            ></v-text-field>
                        </v-card-title>
                        <v-card-text>

                            <v-btn v-if="!soloLectura" small 
                                color="teal" 
                                dark @click="agregarTransferencia=true"
                            >Transferir recurso</v-btn>

                            <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items="transferencias"
                            :search="search"
                            :items-per-page="50"
                            :footer-props="{ 
                                itemsPerPageOptions: [10,30,50,100,-1],
                                itemsPerPageText: 'Registros: '
                            }"
                            >
                                <template slot="item" slot-scope="props">
                                    <tr>
                                        <td class="text-xs-left">
                                            <menu-item v-if="!soloLectura && props.item.operacion == 'Transfiere'"
                                                :items="menuItems"
                                                :id="props.item"
                                                @menuAction="menuAction"
                                            />
                                        </td>
                                        <td class="text-xs-left"> {{fechaTxt(props.item.fecha)}}</td>
                                        <td class="text-xs-left">{{ props.item.operacion}}</td>
                                        <td><a @click="$router.push('/partida/'+props.item.partida._id)">{{ props.item.partida.numero }}</a></td>
                                        <td class="text-xs-left">{{ props.item.solicita}}</td>
                                        <td class="text-xs-left">{{props.item.concepto}}</td>
                                        <td class="text-xs-left">
                                            <font v-if="props.item.operacion == 'Transfiere'" color="#C00"><b>-</b></font>
                                            <font v-else color="#0C0"><b>+</b></font>
                                            {{moneda(props.item.cantidad)}}
                                        </td>
                                        <td class="text-xs-left">{{moneda(props.item.presupuestoModificado)}}</td>
                                    </tr>
                                </template>

                            </v-data-table>
                        </v-card-text>
                    </v-card>
              </v-col>
          </v-row>
      </v-container>

      <agregar-transferencia-component 
        v-if="agregarTransferencia"
        :mostrar="agregarTransferencia"
        :idPartida="idPartida"
        @cancelar="agregarTransferencia=false"
        @transferenciaAgregada="transferenciaAgregada"
      />

      <modificar-transferencia-component 
        v-if="modificarTransferencia.mostrar"
        :mostrar="modificarTransferencia.mostrar"
        :transferencia="modificarTransferencia.transferencia"
        :idPartida="idPartida"
        @cancelar="modificarTransferencia.mostrar=false"
        @transferenciaModificada="transferenciaModificada"
      />


      <!-- ELIMINAR TRANSFERENCIA -->
      <v-dialog v-model="eliminarTransferencia.mostrar" persistent max-width="400px">
        <v-card :loading="loading">
            <v-card-title>
            <span class="headline">Eliminar transferencia</span>
            </v-card-title>
            <v-card-text>
                ¿Está seguro en eliminar la transferencia?<br>
                Esta acción no podrá revertirse.
            </v-card-text>
            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="teal darken-1" small outlined text @click="eliminarTransferencia.mostrar=false">Cancelar</v-btn>
            <v-btn color="teal darken-1" small dark @click="eliminaTransferencia()">Eliminar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>
<script>

const numeral = require('numeral');
import axios from 'axios';
import { mapGetters} from 'vuex'
import moment from 'moment';
moment.locale('es');

import MenuItem from '../menus/MenuItem'
import AgregarTransferenciaComponent from './agregarTransferencia'
import ModificarTransferenciaComponent from './modificarTransferencia'

export default {
    props:['idPartida','transferencias'],
    components:{ MenuItem, AgregarTransferenciaComponent, ModificarTransferenciaComponent },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken",
            "soloLectura"
        ])
    },
    data () {
        return {
            loading: false,
            search: null,
            agregarTransferencia: false,
            modificarTransferencia: {
                mostrar: false,
                transferencia: null
            },
            eliminarTransferencia: {
                mostrar: false,
                transferencia: null
            },
            headers: [
                { text: '', value: '', sortable: false },
                { text: 'Fecha', value: 'fecha', sortable: true },
                { text: 'Operación', value: 'operacion', sortable: true },
                { text: 'Partida', value: 'Partida', sortable: true },
                { text: 'Solicita', value: 'solicita', sortable: true },
                { text: 'Concepto', value: 'concepto', sortable: true },
                { text: 'Cantidad', value: 'cantidad', sortable: true },
                { text: 'Presupuesto', value: '', sortable: true }
            ],
            menuItems:[
                {text:'Modificar datos', action: 'modificarTrans'},
                {text:'Eliminar transferencia', action: 'eliminarTrans'},
            ]
        }
    },
    mounted(){
        this.ordenarTransferencias();
    },
    methods:{
        fechaTxt(fecha){
            return moment(fecha,'YYYY-MM-DD').format('DD/MM/YYYY');
        },
        moneda(numero){
            if(isNaN(numero)) return '';
            const options2 = { style: "currency", currency: "USD" };
            const numberFormat2 = new Intl.NumberFormat("en-US", options2);
            if(numero==0) return (numberFormat2.format(0));
            return (numberFormat2.format(numero));
        },
        calcularSubtotal(){
            let sumatoria = 0;
            this.objetivo.partidas.forEach(partida => {
                sumatoria += partida.montoActual;
            });
            this.subtotal = sumatoria;
        },
        ordenarTransferencias(){
            this.transferencias.sort((a,b)=>(a.fecha > b.fecha) ? 1 : ((b.fecha > a.fecha) ? -1 : 0));
        },
        objetivoParticularModificado(objetivo){
            this.objetivo = objetivo;
            this.modificarObjetivo = false;
        },
        transferenciaAgregada(partida){
            this.agregarTransferencia = false;
            this.$emit('transferenciaAgregada');
        },
        transferenciaModificada(){
            this.modificarTransferencia.mostrar = false;
            this.$emit('transferenciaModificada');
        },
        menuAction(action, transferencia){
            // console.log(transferencia);
            switch(action){
                case 'modificarTrans':
                    this.modificarTransferencia.transferencia = transferencia;
                    this.modificarTransferencia.mostrar = true;
                    break;
                case 'eliminarTrans':
                    this.eliminarTransferencia.transferencia = transferencia;
                    this.eliminarTransferencia.mostrar = true;
                    break;

            }
            // console.log(action, id);
        },
        eliminaTransferencia(){
            this.loading = true;
            axios.delete(this.httpURL+'/partidas/transferencia/'+this.eliminarTransferencia.transferencia._id,
                {headers:{token:this.sessionToken}})
                .then(res => {
                    if( res.data.ok){
                        this.$emit('transferenciaEliminada',this.eliminarTransferencia.transferencia._id);
                        this.eliminarTransferencia.mostrar = false;
                    }else
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                    this.loading = false;
                });
            }
    }
}
</script>